export const INVALID_BOOKING = "invalid_booking";
export const CHECKED_OUT = "checked_out";
export const AWAITING_APPROVAL = "awaiting_approval";
export const HOTEL_GUEST = "hotel_guest";
export const FUTURE_GUEST = "future_guest";